/* RevitaPaw Home — hero choreography, trigger carousel, home sticky ATC,
   final-close reveal. SAFE BY DEFAULT: everything is visible without JS;
   scripts only arm (.pre) then play, with safety timers. */
(function(){
'use strict';
var R=window.RP_REDUCED||window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── HERO load choreography (ADJ-18 stack; entrance pass 2026-07-29: the
   supporting sentence joins the sequence — TITLE leads, then rating → sentence
   → CTA → widgets rise in a quick stagger, one coordinated entrance. Safety
   model unchanged: JS-armed .pre only (JS off = visible), reduced-motion
   skips arming, 3s timer force-reveals stragglers.) ── */
if(!R){
  var ids=['heroRating','heroSub','heroBtns','heroBadges','heroStats','heroFrame'];
  var els=ids.map(function(id){return document.getElementById(id)}).filter(Boolean);
  var words=Array.prototype.slice.call(document.querySelectorAll('#heroH1 .word'));
  var all=els.concat(words);
  all.forEach(function(el){el.classList.add('pre')});
  var on=function(el){if(el)el.classList.add('in')};
  var byId=function(id){on(document.getElementById(id))};
  window.addEventListener('load',function(){
    setTimeout(function(){byId('heroFrame')},60);
    words.forEach(function(w,i){setTimeout(function(){on(w)},120+i*50)});
    setTimeout(function(){byId('heroRating')},330);
    setTimeout(function(){byId('heroSub')},410);
    setTimeout(function(){byId('heroBtns')},490);
    setTimeout(function(){byId('heroBadges')},560);
    setTimeout(function(){byId('heroStats')},620);
  });
  setTimeout(function(){all.forEach(on)},3000); /* safety */
}

/* ── Home sticky ATC (ADJ-09): shows once the hero CTA scrolls off,
   hides whenever ANY full-width CTA (.cta-watch) is on screen ── */
var stickyVisible=false;
(function(){
  var bar=document.getElementById('homeStickyBar'),hero=document.getElementById('heroBtns');
  if(!bar||!hero)return;
  var watch=Array.prototype.slice.call(document.querySelectorAll('.cta-watch'));
  var visible=new Set();
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){e.isIntersecting?visible.add(e.target):visible.delete(e.target)});
    },{threshold:.4});
    watch.forEach(function(el){io.observe(el)});
  }
  window.addEventListener('scroll',function(){
    var heroGone=hero.getBoundingClientRect().bottom<0;
    stickyVisible=heroGone&&visible.size===0;
    bar.classList.toggle('show',stickyVisible);
    document.body.classList.toggle('rp-bar-shown',stickyVisible);
  },{passive:true});
})();

/* ── Trigger carousel (ADJ-17): native scroll-snap, dots, arrows,
   capped scroll-linked drift on desktop (never scroll-jacks) ── */
var trigTrack=document.getElementById('trigTrack');
var trigN=trigTrack?trigTrack.children.length:0;
var trigI=0;
function trigSync(i){
  trigI=Math.max(0,Math.min(i,trigN-1));
  document.querySelectorAll('.trig-dot').forEach(function(d,j){d.classList.toggle('on',j===trigI)});
}
window.trigTo=function(i){
  if(!trigTrack)return;
  var slide=trigTrack.children[i];
  if(slide)trigTrack.scrollTo({left:slide.offsetLeft-trigTrack.offsetLeft,behavior:R?'auto':'smooth'});
  trigSync(i);
};
window.trigGo=function(dir){trigTo(trigI+dir)};
/* before/after tap-flip (2026-07-28): per-card toggle only — never scrolls the
   carousel (plain button click; native snap-scroll is untouched) */
window.trigFlip=function(btn){
  var on=btn.classList.toggle('on');
  btn.setAttribute('aria-pressed',on?'true':'false');
  var lbl=btn.getAttribute('aria-label')||'';
  btn.setAttribute('aria-label',on?lbl.replace('Show after photo','Show before photo'):lbl.replace('Show before photo','Show after photo'));
};
if(trigTrack){
  var tTO;
  trigTrack.addEventListener('scroll',function(){
    clearTimeout(tTO);
    tTO=setTimeout(function(){
      var kids=trigTrack.children,best=0,bd=1e9;
      for(var i=0;i<kids.length;i++){
        var d=Math.abs(kids[i].offsetLeft-trigTrack.offsetLeft-trigTrack.scrollLeft);
        if(d<bd){bd=d;best=i}
      }
      trigSync(best);
    },80);
  },{passive:true});
  /* desktop drift: translateX capped well under 15% of track width */
  if(!R&&window.matchMedia('(min-width:900px)').matches){
    var band=trigTrack.closest('.bandnavy');
    window.addEventListener('scroll',function(){
      if(!band)return;
      var r=band.getBoundingClientRect(),vh=window.innerHeight;
      var p=Math.max(0,Math.min(1,(vh-r.top)/(vh+r.height))); /* 0..1 through viewport */
      var max=Math.min(trigTrack.scrollWidth*.06,60);
      trigTrack.style.transform='translateX('+((.5-p)*2*max)+'px)';
    },{passive:true});
  }
}

/* (product-gallery thumb builder removed 2026-07-28 — section deleted in
   the restructure) */

/* (fcReassure reveal removed 2026-07-27 — final close now uses navy chips) */
})();

/* (comparison tick reveal moved to rp-shared.js 2026-07-27 — the comparison
   band now renders on the PDP too) */

/* ── Purchase module (DARK, homepage): the PDP buy box's compact module with
   the same locked wiring — prices ONLY from data attrs (Liquid-rendered cents
   from variants + selling_plan_allocations), the selling_plan input enabled
   only in subscribe mode (the no-JS POST stays one-time), dog size = dosing
   UI ONLY (never touches price/variant). The sticky-bar form follows the
   module selection so it always adds exactly what the module shows. ── */
var hbState={i:1,sub:false,plan:null,size:0};
function hbMoney(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'')}
function hbCards(){return [].slice.call(document.querySelectorAll('#hbCards .bundle-opt'))}
function hbPrice(card){
  if(!hbState.sub)return Number(card.dataset.price);
  try{var m=JSON.parse(card.dataset.subPrices||'{}');if(m[hbState.plan]!=null)return Number(m[hbState.plan])}catch(e){}
  return Number(card.dataset.price);
}
function hbUpdate(){
  var cards=hbCards();if(!cards.length)return;
  var sel=cards[hbState.i]||cards[0];
  var pills=document.querySelectorAll('#hbSizeSeg .size-pill');
  var pill=pills[hbState.size]||pills[0];
  if(pill)cards.forEach(function(c,j){
    var el=document.getElementById('hbSupply'+j);
    var v=pill.getAttribute('data-sup'+(j+1));
    if(el&&v)el.textContent=v+' approx. supply';
  });
  var tubs=Number(sel.dataset.tubs)||1;
  var p1=Number(cards[0].dataset.price);
  var save=p1*tubs-Number(sel.dataset.price);
  var saveMax=p1*3-Number(cards[2].dataset.price);
  var line=document.getElementById('hbSvLine'),fill=document.getElementById('hbSvFill');
  if(line){
    if(tubs===1)line.innerHTML='Add 1 more tub to start saving';
    else if(tubs===2)line.innerHTML='You\u2019re saving <b class="sv-amt">'+hbMoney(save)+'</b> \u2014 add 1 more tub to save <b class="sv-amt">'+hbMoney(saveMax)+'</b>';
    else line.innerHTML='Maximum saving unlocked \u2014 you save <b class="sv-amt">'+hbMoney(saveMax)+'</b>';
  }
  if(fill)fill.style.width=(tubs===1?'0%':tubs===2?Math.round(save/saveMax*100)+'%':'100%');
  var p=hbPrice(sel);
  /* non-stacking rule (P0 §4, applied sitewide): WELCOME10 shows only in
     one-time mode — the subscription's 10% applies INSTEAD, never on top */
  var wEl=document.getElementById('hbWelcome');
  if(wEl)wEl.hidden=hbState.sub;
  var w=wEl?wEl.querySelector('b'):null;
  if(w&&!hbState.sub)w.textContent=hbMoney(Math.round(p*0.9));
  var sn=document.querySelector('#hbSubBody .js-sub-price');
  if(sn&&hbState.plan!=null){try{var sm=JSON.parse(sel.dataset.subPrices||'{}');if(sm[hbState.plan]!=null)sn.textContent=hbMoney(sm[hbState.plan])}catch(e){}}
  /* CTA system 2026-07-28: the preview's CTA deep-links to the PDP with the
     full selection — variant + selling_plan (subscribe only) + size — so the
     PDP lands pre-selected and checkout happens THERE (no on-page checkout). */
  var go=document.getElementById('hbGoLink');
  if(go){
    var sizeNames=['small','medium','large'];
    var href='/products/daily-calm-chews?variant='+sel.dataset.variantId;
    if(hbState.sub&&hbState.plan)href+='&selling_plan='+hbState.plan;
    href+='&size='+(sizeNames[hbState.size]||'small');
    go.setAttribute('href',href);
  }
}
window.hbSelect=function(el,i){
  hbState.i=i;
  hbCards().forEach(function(c,j){var on=j===i;c.classList.toggle('on',on);c.setAttribute('aria-checked',String(on))});
  hbUpdate();
};
window.hbSize=function(btn,i){
  hbState.size=i;
  document.querySelectorAll('#hbSizeSeg .size-pill').forEach(function(b,j){var on=j===i;b.classList.toggle('on',on);b.setAttribute('aria-checked',String(on))});
  var st=document.getElementById('hbSizeDose');
  if(st)st.innerHTML=(btn.dataset.name||'Small')+' dog \u00b7 <b>'+(btn.dataset.dose||'')+'</b>';
  try{sessionStorage.setItem('rp_size',String(i))}catch(e){}
  hbUpdate(); /* supplies + status only — variant/price stay bundle-driven */
};
window.hbMode=function(sub){
  sub=!!sub;if(hbState.sub===sub)return;
  hbState.sub=sub;
  var a=document.getElementById('hbPtOne'),b=document.getElementById('hbPtSub'),body=document.getElementById('hbSubBody');
  if(a){a.classList.toggle('on',!sub);a.setAttribute('aria-checked',String(!sub))}
  if(b){b.classList.toggle('on',sub);b.setAttribute('aria-checked',String(sub))}
  if(body)body.classList.toggle('open',sub);
  hbUpdate();
};
window.hbSetFreq=function(v){hbState.plan=Number(v);hbUpdate()};
/* (hbAtc removed 2026-07-28 — the preview CTA is a deep link, no on-page
   checkout on the homepage) */
(function(){
  /* gate on the module itself — #hbForm died with the on-page checkout
     (2026-07-28); gating on it skipped this init, so hbState.plan stayed
     null and a subscribe deep link silently dropped its selling_plan */
  if(!document.getElementById('hbCards'))return;
  var sel=document.getElementById('hbFreq');
  hbState.plan=sel&&sel.value?Number(sel.value):null;
  try{var s=Number(sessionStorage.getItem('rp_size'));
    if(s>=1&&s<=2){var p=document.querySelectorAll('#hbSizeSeg .size-pill')[s];if(p)window.hbSize(p,s)}
  }catch(e){}
  hbUpdate();
})();

/* (review-carousel sync moved to rp-shared.js 2026-07-27 — the two-row photo
   reviews now render on the PDP too, which doesn't load this file) */


/* (calm-stack ingMore MOVED to rp-shared.js 2026-07-28 — the shared
   rp-calmstack snippet renders on the PDP too, which doesn't load this file) */
